import { useSelect } from "@refinedev/antd";
import { IUser } from "interfaces";
import { APP_WRITE_TIME_REPORT_USER_ID } from "utility/constants";

export const UserSelectOptions = () => {
  const { selectProps: userSelectProps } = useSelect<IUser>({
    resource: APP_WRITE_TIME_REPORT_USER_ID,
    optionLabel: "name",
    optionValue: "id",
    sorters: [
      {
        field: "name",
        order: "asc",
      },
    ],
  });
  return (
    {userSelectProps}
  );
};